var defaultProps = {
  spacing: null,
  children: [],
  containerProps: {}
};

export { defaultProps };
//# sourceMappingURL=defaultProps.js.map
